<template>
  <div>
    <v-card-text>
      <v-row>
        <!--<v-col
          v-if="permisos.includes('nomenclators_currencies:create') || permisos.includes('*')"
          cols="12"
          md="2"
        >
          <v-btn
            color="primary"
            class="mb-4 me-3"
            @click="newItem"
          >
            <v-icon>{{ icons.mdiPlus }}</v-icon>
            <span>{{ $t('btn.insert') }}</span>
          </v-btn>
        </v-col>-->

        <v-spacer></v-spacer>

        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="itemsPerPage"
            :label="$t('lbl.itemsPerPage')"
            type="number"
            min="5"
            hide-details
            dense
            outlined
            @input="load()"
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="search"
            :append-icon="icons.mdiMagnify"
            :label="$t('btn.search')"
            single-line
            hide-details
            dense
            outlined
            @input="load()"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>
    <v-form class="multi-col-validation px-5 py-5">
      <v-row>
        <v-col
          cols="12"
          md="12"
          class="text-right"
        >
          {{ totalF }} {{ $t('lbl.de') }} {{ totalItems }} {{ $t('lbl.currencies') | lowercase }}
        </v-col>
      </v-row>
    </v-form>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              width="5%"
              style="text-align: center;"
            ></th>
            <th class="text-uppercase">
              {{ $t('lbl.name') }}
            </th>
            <th
              width="10%"
              class="text-uppercase"
              style="text-align: center;"
            >
              {{ $t('lbl.code') }}
            </th>
            <th
              width="10%"
              class="text-uppercase"
              style="text-align: center;"
            >
              {{ $t('lbl.order') }}
            </th>
            <th
              width="10%"
              class="text-uppercase"
              style="text-align: center;"
            >
              {{ $t('lbl.state') }}
            </th>
            <!--<th
              v-if="permisos.includes('nomenclators_currencies:edit') || permisos.includes('*')"
              width="10%"
              class="text-uppercase"
              style="text-align: center;"
            >
              {{ $t('lbl.actions') }}
            </th>-->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(iten, index) in items"
            :key="index"
          >
            <td style="text-align: center;">
              <span v-if="iten.symbol">{{ iten.symbol }}</span>
            </td>
            <td>
              {{ iten.name }}
            </td>
            <td style="text-align: center;">
              {{ iten.code }}
            </td>
            <td style="text-align: center;">
              {{ iten.order }}
            </td>
            <td style="text-align: center;">
              <v-chip
                v-if="!iten.active"
                small
                color="error"
                class="v-chip-light-bg font-weight-semibold text-capitalize error--text"
              >
                <span>Inactiva</span>
              </v-chip>
              <v-chip
                v-else
                small
                :color="iten.active ? 'success' : 'error'"
                :class="iten.active ? 'success--text' : 'error--text'"
                class="v-chip-light-bg font-weight-semibold text-capitalize"
              >
                <span v-if="iten.active">Activa</span>
              </v-chip>
            </td>
            <!--<td
              v-if="permisos.includes('nomenclators_currencies:edit') || permisos.includes('*')"
              style="text-align: center;"
            >
              <v-menu
                v-if="permisos.includes('nomenclators_currencies:edit') || permisos.includes('*')"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-if="permisos.includes('nomenclators_currencies:edit')"
                    link
                    @click="editItem(iten)"
                  >
                    <v-list-item-title>
                      <v-btn icon>
                        <v-icon>{{ icons.mdiSquareEditOutline }}</v-icon>
                      </v-btn>
                      <span>{{ $t('btn.edit') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>-->
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-card-text class="pt-2">
      <v-row>
        <v-col
          lg="12"
          cols="12"
          class="d-flex justify-end"
        >
          <v-pagination
            v-model="pagination.current"
            :length="pagination.total"
            total-visible="5"
            @input="onPageChange"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiSquareEditOutline,
  mdiPlus,
  mdiArrowLeft,
  mdiUpdate,
  mdiFormatListText,
  mdiDotsVertical,
} from '@mdi/js'

export default {
  data() {
    return {
      search: '',
      items: [],
      totalItems: 0,
      totalF: 0,
      pagination: {
        current: 1,
        total: 0,
      },
      itemsPerPage: 10,
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiSquareEditOutline,
        mdiPlus,
        mdiArrowLeft,
        mdiUpdate,
        mdiFormatListText,
        mdiDotsVertical,
      },
      loading: false,
      isDialogVisible: false,
      isDialogVisibleDelete: false,
      item: {},
      abilities: [],
      abilityList: [],
      checkPermiso: 1,
      permisos: sessionStorage.getItem('permisos_auth'),
    }
  },
  mounted() {
    this.load()
    this.loadAll()
  },
  methods: {
    load() {
      this.axios
        .get(`currency_list?page=${this.pagination.current}&per_page=${this.itemsPerPage}&search=${this.search}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            this.items = res.data.data
            this.pagination.current = res.data.meta.current_page
            this.pagination.total = res.data.meta.last_page

            this.totalF = res.data.meta.total - 1
          }
        })
    },
    loadAll() {
      this.axios
        .get('currency_list?per_page=100000', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          // eslint-disable-next-line no-empty
          if (res.data.success === false) {
          } else {
            this.totalItems = res.data.meta.total - 1
          }
        })
    },
    onPageChange() {
      this.load()
    },
    newItem() {
      sessionStorage.removeItem('nomenclators-currencies-id')
      this.$router.push({ name: 'nomenclators-currencies-update' })
    },
    editItem(iten) {
      sessionStorage.setItem('nomenclators-currencies-id', iten.id)
      this.$router.push({ name: 'nomenclators-currencies-update' })
    },
    deleteItem(iten) {
      this.isDialogVisibleDelete = true
      this.item = iten
      this.itemId = iten.id
    },
    confirmDelete() {
      this.loading = true
      this.axios
        .delete(`nomenclators_currencies/${this.itemId}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            if (res.data.data.status === 402) {
              this.$toast.error(this.$t('msg.notDeleteItem'))
            }
          } else {
            this.$toast.success(this.$t('msg.infoSuccess'))
          }
        })
        .finally(() => this.reseat())
    },
    reseat() {
      this.isDialogVisible = false
      this.isDialogVisibleDelete = false
      this.item = {}
      this.itemId = null
      this.loading = false
      this.load()
      this.loadAll()
    },
  },
}
</script>

<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
